var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "ideas-users" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-row",
          [
            _c("el-col", [
              _c("div", { staticClass: "steps-wrapper" }, [
                _c("div", { staticClass: "step" }, [
                  _c("p", [
                    _vm._v(" Sign Up "),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]),
                _c("div", { staticClass: "step" }, [
                  _c("p", [
                    _vm._v(" Choose Your Plan "),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]),
                _c("div", { staticClass: "step active" }, [
                  _c("p", [
                    _vm._v(" Ideas and Users "),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]),
                _c("div", { staticClass: "step" }, [
                  _c("p", [
                    _vm._v(" Review and Pay "),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", [
              _c("div", { staticClass: "hero-section" }, [
                _c("h1", [_vm._v(" Select number of ideas")]),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", [
              _c("div", { staticClass: "sub-hero" }, [
                _vm._v(" All prices in USD "),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          { attrs: { type: "flex" } },
          [
            _c("el-col", { staticClass: "card-holder", attrs: { span: 14 } }, [
              _c("p", { staticClass: "info-text info-text__top" }, [
                _c("span", [_vm._v("Have a coupon?")]),
                _vm._v(
                  " Wait until you reach the final payment screen, and you can enter it there. "
                ),
              ]),
              _c("div", { staticClass: "card-wrapper card-wrapper__left" }, [
                _c("div", { staticClass: "heading-wrapper" }, [
                  _c("h2", [_vm._v(" How many ideas you plan to have? ")]),
                ]),
                _c(
                  "div",
                  { staticClass: "slider-wrapper" },
                  [
                    _c("el-slider", {
                      attrs: {
                        step: 25,
                        marks: _vm.marks,
                        "show-stop": "",
                        "show-tooltip": _vm.tooltipDisplay,
                      },
                      model: {
                        value: _vm.value,
                        callback: function ($$v) {
                          _vm.value = $$v
                        },
                        expression: "value",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "info-wrapper" }, [
                  _c(
                    "p",
                    { staticClass: "info" },
                    [
                      _c("span", { staticClass: "info-inner" }, [
                        _vm._v(" " + _vm._s(_vm.record.ideas) + " "),
                      ]),
                      _vm.record.ideas > 1
                        ? [_vm._v(" Ideas ")]
                        : [_vm._v(" Idea ")],
                    ],
                    2
                  ),
                ]),
              ]),
              _c("p", { staticClass: "info-text info-text__bottom" }, [
                _vm._v(
                  " All subscriptions will be automatically renewed from your selected payment method on a recurring basis, and we’ll send you a receipt each time. We do not store your card details. You can upgrade, downgrade, or cancel anytime. If the subscription is canceled, refunds and termination of access will follow the Terms of Use. Prices are in US Dollars and subject to change. Other restrictions and taxes may apply. "
                ),
              ]),
            ]),
            _c("el-col", { staticClass: "card-holder", attrs: { span: 10 } }, [
              _c(
                "div",
                { staticClass: "card-wrapper" },
                [
                  _c("h4", [_vm._v(" YOUR BILL ")]),
                  _c("div", { staticClass: "heading-wrapper flex-heading" }, [
                    _c("h2", [_vm._v(" " + _vm._s(_vm.record.slug) + " ")]),
                    _c("span", { staticClass: "price" }, [
                      _c(
                        "span",
                        {
                          class: {
                            flat:
                              _vm.record.price.toString().slice(-3) === ".00",
                          },
                        },
                        [
                          _c("sup", { staticClass: "currency" }, [_vm._v("$")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                typeof _vm.record !== "undefined"
                                  ? _vm.record.price.toString().slice(0, -3)
                                  : 0
                              ) +
                              " "
                          ),
                          _c("sup", { staticClass: "fraction" }, [
                            _vm._v(
                              _vm._s(
                                typeof _vm.record !== "undefined"
                                  ? _vm.record.price.toString().slice(-3) ===
                                    ".00"
                                    ? ""
                                    : _vm.record.price.toString().slice(-3)
                                  : 0
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "span",
                        { staticClass: "price-text" },
                        [
                          _vm.data.type === "month"
                            ? [_vm._v(" Per Month ")]
                            : _vm._e(),
                          _vm.data.type === "year"
                            ? [_vm._v(" Per Year ")]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-wrapper" }, [
                    _c(
                      "p",
                      { staticClass: "info" },
                      [
                        _c("span", { staticClass: "info-inner" }, [
                          _vm._v(" " + _vm._s(_vm.record.ideas) + " "),
                        ]),
                        _vm.record.ideas > 1
                          ? [_vm._v(" Ideas ")]
                          : [_vm._v(" Idea ")],
                      ],
                      2
                    ),
                  ]),
                  _vm.data.type === "month"
                    ? [
                        _c("h3", [_vm._v(" Billed Monthly ")]),
                        _c(
                          "p",
                          {
                            staticClass: "sub-text",
                            on: { click: _vm.updateType },
                          },
                          [_vm._v(" Change to yearly and save 40% ")]
                        ),
                      ]
                    : _vm._e(),
                  _vm.data.type === "year"
                    ? [
                        _c("h3", [_vm._v(" Billed Yearly ")]),
                        _c(
                          "p",
                          {
                            staticClass: "sub-text",
                            on: { click: _vm.updateType },
                          },
                          [
                            _c("span", { staticClass: "switch-to" }, [
                              _vm._v(" Switch to monthly "),
                            ]),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _c("hr"),
                  _c("div", { staticClass: "bottom-card" }, [
                    _c("div", { staticClass: "left-side" }, [
                      _c("h3", [_vm._v(" TOTAL ")]),
                    ]),
                    _c("div", { staticClass: "right-side" }, [
                      _c(
                        "span",
                        { staticClass: "price" },
                        [
                          _c(
                            "span",
                            {
                              class: {
                                flat:
                                  _vm.record.price.toString().slice(-3) ===
                                  ".00",
                              },
                            },
                            [
                              _c("sup", { staticClass: "currency" }, [
                                _vm._v("$"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    typeof _vm.record !== "undefined"
                                      ? _vm.record.price.toString().slice(0, -3)
                                      : 0
                                  ) +
                                  " "
                              ),
                              _c("sup", { staticClass: "fraction" }, [
                                _vm._v(
                                  _vm._s(
                                    typeof _vm.record !== "undefined"
                                      ? _vm.record.price
                                          .toString()
                                          .slice(-3) === ".00"
                                        ? ""
                                        : _vm.record.price.toString().slice(-3)
                                      : 0
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm.data.type === "month"
                            ? [
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(" Per Month "),
                                ]),
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(" + taxes "),
                                ]),
                              ]
                            : _vm._e(),
                          _vm.data.type === "year"
                            ? [
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(" Per Year "),
                                ]),
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v("+ taxes "),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "secured" }, [
                    _c("i", { staticClass: "el-icon-lock" }),
                    _vm._v(
                      " All payments are safe and secured with SSL encryption "
                    ),
                  ]),
                ],
                2
              ),
            ]),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c("el-col", [
              _c("hr"),
              _c("div", { staticClass: "btn-pay-wrapper" }, [
                _c(
                  "button",
                  { staticClass: "back", on: { click: _vm.stepBack } },
                  [_vm._v(" Back to plans ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "review-pay",
                    on: {
                      click: function ($event) {
                        _vm.$store.getters["user/isSubscribed"] &&
                        _vm.$store.state.user.subscription.status !==
                          "deleted" &&
                        !_vm.$store.state.user.freeTrial
                          ? _vm.triggerPayment()
                          : _vm.triggerPaddle()
                      },
                    },
                  },
                  [_vm._v(" Review and Pay ")]
                ),
              ]),
            ]),
          ],
          1
        ),
        _c("dialog-confirm", {
          attrs: {
            visible: _vm.dialogConfirm,
            "preview-data": _vm.previewData,
            record: _vm.record,
            data: _vm.data,
          },
          on: {
            "close-dialog": function ($event) {
              _vm.dialogConfirm = false
            },
            "confirm-dialog": _vm.confirmedUpdatePlan,
          },
        }),
        _c("dialog-thank-you", {
          attrs: {
            "dialog-thank-you-visible": _vm.dialogThankYouVisible,
            "thank-you-data": _vm.chosedData,
          },
          on: { "close-dialog": _vm.closeDialog },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }